module.exports = ".btn-approve {\r\n    background: #00bf80;\r\n    margin-left: 4px;\r\n    color: white;\r\n}"